/**
 * Shared helpers for case infrastructure components.
 *
 * Extracted from CaseInfrastructureTab.tsx (sub-PR 6.2).
 */

const IT_SYSTEM_TYPES = new Set([
  'workstation',
  'server',
  'domain_controller',
  'file_server',
  'mail_server',
  'web_server',
  'database_server',
  'network_device',
  'mobile_device',
  'firewall',
  'router',
  'switch',
  'load_balancer',
  'cloud_instance',
  'container',
  'virtual_machine',
  'iot_device',
])

export function isItSystemType(deviceType: string): boolean {
  return IT_SYSTEM_TYPES.has(deviceType)
}

export const VALID_DEVICE_TYPES = new Set([
  'workstation',
  'laptop',
  'desktop',
  'server',
  'domain_controller',
  'database_server',
  'web_server',
  'file_server',
  'email_server',
  'proxy_server',
  'firewall',
  'router',
  'switch',
  'load_balancer',
  'cloud_instance',
  'container',
  'mobile_device',
  'iot_device',
  'network_device',
  'virtual_machine',
  'unknown',
  'other',
  // Document types
  'office_document',
  'pdf_document',
  'email',
  'log_file',
  'configuration_file',
  'database_export',
  'other_document',
  // Data types
  'database_record',
  'credential',
  'api_key',
  'certificate',
  'other_data',
])
